import { combineReducers } from 'redux';
import { login, user } from './usersReducer';

const rootReducer = combineReducers({
  login,
  user,
});

export default rootReducer;
